<template>
    <div>
        <v-form v-if="dataSource" class="wrapperForm">
            <v-row dense>
                <v-col cols="12" sm="12" md="12" class="section-wrapper">
                    <v-card-panel title="Запросы_на_продление_контрольного_срока">
                        <template v-slot:titleactions>              
                            <div class="fbt-slider">
                                <div class="prev-title">{{$t('Показать_все')}}</div>
                                <v-switch 
                                    v-model="showAll" 
                                    class="cust-switch" 
                                    inset 
                                    hide-details                                               
                                >
                                </v-switch>
                                <div
                                    class="arrow-dropdown"
                                    @click="toggleAll"
                                >
                                    <v-icon 
                                    role="button" 
                                    small 
                                    left>
                                        {{ openAll ? "fas fa-chevron-down" : "fas fa-chevron-up" }}
                                    </v-icon>
                                </div>
                            </div>
                        </template>
                    
                        <div class="resol-tree-wrapper">
                            <div class="resol-tree-header">
                                <div style="width: 60%;padding-left:18px;">{{ $t("Инициированно") }}</div>
                                <div style="width: 12%;flex-shrink: 0;">{{ $t("Рассмотривающий") }}</div>
                                <div style="width: 12%;flex-shrink: 0;">{{ $t("Рассмотренно") }}</div>
                                <div style="width: 16%;flex-shrink: 0;">{{ $t("Решение") }}</div>
                                <div style="width: 160px;flex-shrink: 0;">{{ $t("Статус") }}</div>
                                <div class="resol-tree-action-col"></div>
                            </div>
                            <div class="resol-tree">
                                <div v-for="item in requests" :key="item.id" class="div-table-rows-container">
                                    <div class="div-table-row">
                                        <!-- Ячейка Инициированно-->
                                        <div class="div-table-row-cell" style="width: 60%" >
                                            
                                            <div class="elipsis-text-wrap">
                                                <!--Toggle-->
                                                <i :class="[ openAll || opened.includes(item.id) ? 'fas fa-caret-down' : 'fas fa-caret-right']" @click.stop="toggle(item.id)"></i>
                                                <span>
                                                    {{ $moment(item.RequestDate).format('DD.MM.YYYY HH:mm:ss') }}
                                                </span>
                                                <v-employee-chip
                                                    :id="item.SenderEmployeeId"
                                                    :name="item.SenderName"
                                                    :is-employee="true"
                                                />
                                                <div class="etw-text-container" v-tooltip.top-center="getRequestsText(item)">
                                                    <span class="etw-text">
                                                        {{ getRequestsText(item) }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <!-- Ячейка Рассмотривающий-->
                                        <div class="div-table-row-cell" style="width: 12%;flex-shrink: 0;" >
                                            
                                            <div class="elipsis-text-wrap">
                                                <v-employee-chip
                                                    v-if="item.CloseEmployeeId != '00000000-0000-0000-0000-000000000000'"
                                                    :id="item.CloseEmployeeId"
                                                    :name="item.CloseEmployeeName"
                                                    :is-employee="true"
                                                />
                                            </div>
                                        </div>

                                        <!-- Ячейка Рассмотренно-->
                                        <div class="div-table-row-cell" style="width: 12%;flex-shrink: 0;" >
                                            
                                            <div class="elipsis-text-wrap">
                                                <div class="etw-text-container" 
                                                    v-if="item.CloseDate"
                                                    v-tooltip.top-center="$moment(item.CloseDate).format('DD.MM.YYYY HH:mm:ss')"
                                                >
                                                    <span class="etw-text">
                                                        {{ $moment(item.CloseDate).format('DD.MM.YYYY HH:mm:ss') }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Ячейка Решение-->
                                        <div class="div-table-row-cell" style="width: 16%;flex-shrink: 0;" >
                                            <div class="elipsis-text-wrap">
                                                <div class="etw-text-container" 
                                                    v-tooltip.top-center="getSolution(item)"
                                                >
                                                    <span :class="[item.Status == 3 || (item.Status == 2 && !item.Comment) ? 'font-italic !important' : '', 'etw-text']">
                                                        {{ getSolution(item) }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Ячейка Статус-->
                                        <div class="div-table-row-cell" style="width: 160px;flex-shrink: 0;">
                                            <div class="onlyReadData more-per-lab-wrap"> 
                                                <StatusChip
                                                    :status="getStatusObject(item.Status)"
                                                />
                                            </div>
                                        </div>

                                        <!--Ячейка действий -->
                                        <div class="resol-tree-action-col">
                                            <v-popover
                                                trigger="click"
                                                v-if="canCancelRequest(item)"
                                            >
                                                <v-chip
                                                    class="person-label"
                                                    small
                                                    label
                                                    color="orange lighten-3"
                                                >
                                                    <v-icon color="#494F59">fas fa-ellipsis-v</v-icon>
                                                </v-chip>

                                                <template slot="popover">
                                                    <ul class="ribbon-button-submenu">
                                                        <li
                                                            @click="cancelRequest"
                                                            v-close-popover
                                                        >
                                                            <v-icon left>
                                                                fas fa-ban
                                                            </v-icon>
                                                        {{ $t('Отменить_запрос') }}
                                                        </li>
                                                    </ul>
                                                    <span class="ribbon-button-submenu-title">{{ $t("Подменю_действий") }}</span>
                                                </template>
                                            </v-popover>
                                        </div>
                                    </div>
                                    <div v-if="openAll || opened.includes(item.id)" class="div-table-row">
                                        <div class="div-table-row-cell" style="width: 40%; margin-left: 30px" >
                                            
                                            <div class="elipsis-text-wrap">
                                                <span>
                                                    {{ $t('Основание') }}: {{ item.Subject }}
                                                </span>
                                                <div v-if="item.Attachments && item.Attachments.length > 0" class="onlyReadData more-per-lab-wrap">
                                                    <v-chip v-for="(attachment, index) in item.Attachments" 
                                                        class="person-label file-label"
                                                        small
                                                        label
                                                        :key="index"
                                                        v-tooltip.top-center="attachment.Name"
                                                    >
                                                        <i class="fas fa-file-alt"></i>
                                                        <div>{{ $refTruncateFilename(attachment.Name) }}</div>
                                                        <i class="fas fa-download" @click="onDownload(attachment.id, attachment.Name)"></i>
                                                    </v-chip>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-card-panel>
                </v-col>
            </v-row>
        </v-form>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Axios from 'axios';
import { httpAPI } from "@/api/httpAPI";
import sys from "@/services/system"
import StatusChip from '@/components/global/chips/StatusChip'
import VCardPanel from '../card/v-card-panel.vue';

export default {
    name: "prolongaterequests-tab",
    props: {
        id: {
            type: String,
            default: null,
            
        }
    },
    components: {
        StatusChip,
        VCardPanel,
    },
    data() {
        return {
            cancellationTokenSorce: null,
            dataSource: null,
            showAll: false,
            openAll: false,
            opened: []
        }
    },
    computed: {
        ...mapGetters('global/auth', { userInfo: 'getUserInfo' }),
        ...mapGetters('global/actionsource', { documentId: 'getDataSourceDocumentId', isDataSourceCommon: 'isDataSourceCommon' }),
        requests() {
            return this.dataSource?.filter(item => this.showAll || [0,1].includes(item.Status));
        }
    },
    filters: {
        formattedDate: function (value) {
            var formatedDate = sys.dateFormat(value, 'DD.MM.YYYY');
            return formatedDate ?? "";
        }
    },
    methods: {
        async update() {
            if (this.cancellationTokenSorce)
                this.cancellationTokenSorce.cancel('New request started');

            this.cancellationTokenSorce = Axios.CancelToken.source();

            this.$store.dispatch('setOverlayVisible', { visible: true }, { root: true });

            let response = await httpAPI({
                url: `api/tabs/prolongaterequedts/${this.$props.id}`,
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'isCommon': this.$store.getters['global/actionsource/isDataSourceCommon'] },
                cancelToken: this.cancellationTokenSorce.token,
            });

            this.dataSource = response?.data?.Payload?.Data?.Object;

            this.$store.dispatch('setOverlayVisible', { visible: false }, { root: true });
        },
        async onDownload(attachId, attachName) {
            this.$eventBus.$emit('on-download-file', { id: attachId, name: attachName });
        },
        toggleAll(){
            if (this.openAll)
                this.opened = [];
            else 
                this.opened = this.dataSource.map(item => item.id);
            this.openAll = !this.openAll;
        },
        toggle(id){
            const index = this.opened.indexOf(id);
            if (index === -1) {
                this.opened.push(id);
            } else {
                this.opened.splice(index, 1);
            }
        },
        getRequestsText(item){
            return `${this.$t('Запрашивает_продлить_срок')}: ${ item.PrevControlDate ? this.$moment(item.PrevControlDate).format('DD.MM.YYYY') : this.$t("не_указано")} ➜ ${ this.$moment(item.RequestedControlDate).format('DD.MM.YYYY')}`
        },
        getSolution(item){
            switch (item.Status){
                case 0:
                default:
                    return '';
                case 1:
                    return `${ this.$moment(item.PrevControlDate).format('DD.MM.YYYY')} ➜ ${ this.$moment(item.ApprovedControlDate).format('DD.MM.YYYY')}`;
                case 2:
                    return item.Comment ?? this.$t('Не_указано'); 
                case 3:
                    {
                        if (item.SenderEmployeeId == item.CloseEmployeeId)
                            return this.$t('Отменено_инициатором');
                        else 
                            return this.$t('Снят_с_контроля');
                    }
            }
        },
        getStatusObject(status){
            switch (status) {
                case 0: 
                    return {
                        text: "Отправлен",
                        style: {
                            'background-color': "#9B84EE"
                        }
                    };
                case 1:
                    return {
                        text: "Одобрен",
                        style: {
                            'background-color': "#43B581"
                        }
                    };
                case 2:
                    return {
                        text: "Отклонен",
                        style: {
                            'background-color': "#F04747"
                        }
                    };
                case 3:
                    return {
                        text: "Отменен",
                        style: {
                            'background-color': "#9e9e9e"
                        }
                    };
            }
        },
        canCancelRequest(request){
            return request.Status == 0 && request.SenderWorkplaceId == this.userInfo.WorkplaceId
        },
        async cancelRequest(){
            await this.$store.dispatch(`global/actionsource/CancelProlongationRequest`); 
        },
    },
    async created() {
        await this.update();
    },
    mounted() {        
        this.$eventBus.$on('update-active-tab', async () => {
            if (this.$parent.isActive)
                await this.update();
        });
    },
    destroyed() {
        this.$eventBus.$off('update-active-tab');
    }
}
</script>
